// extracted by mini-css-extract-plugin
export default {"map":"InspectAoiMap_map__m+ch4"};